<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">20<span class="smallcaps">TH </span>M<span class="smallcaps">AY </span>1974</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// may-god-forgive_00004.vue?09769fe8